import { combineReducers } from "redux";

//Reducers
import Reducer from "./Reducer";

//Combine all reducers
export default combineReducers({
  appData: Reducer,
});
